import React, { useRef, useState, useEffect } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { Button, Grid, Typography } from "@material-ui/core";
import dropImage from "../../images/DropImage.svg";
import { filter, range } from "lodash";
import GDPDroppable from "../GDPDroppable";
import DraggableAnswer from "../DraggableAnswer";
import { isMobile } from 'react-device-detect'
import "animate.css/animate.css";
const yesBoxTitles = ["LABOR FORCE", "EMPLOYED"]
const noBoxTitles = ["NOT LABOR FORCE", "UNEMPLOYED"]

const PlayQuiz = (props) => {
  const {
    classes,
    dragStarted,
    setDragStarted,
    onSubmit,
    currentQuestion,
    answers,
    answeredCorrectly,
    setAnsweredCorrectly,
    isEvaluatorModalOpen,
    prevQuestion,
    prevAnswer,
    moveBack,
    openNextSetModal,
    questionSetIndex,
    setAnimationFinished,
    title,
    showQuestion,
    setShowQuestion
  } = props;

  const [inCyclical, setInCyclical] = useState(false);
  const [inFrictional, setInFrictional] = useState(false);
  const [inStructural, setInStructural] = useState(false);
  const [isNoFinished, setIsNoFinished] = useState(false);
  const [currentAnswer, setCurrentAnswer] = useState(null);
  // const [currentPosition, setCurrentPosition] = useState({ x: 0, y: 0 })
  const [answered, setAnswered] = useState(false);
  const [dragChildStarted, setDragChildStarted] = useState(false);
  const [showDropIconSection, setShowDropIconSection] = useState(false);

  const cyclicalRef = useRef(null);
  const frictionalRef = useRef(null);
  const structuralRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setShowDropIconSection(true), 800);
  }, []);

  const onDragUpdate = (e) => {
    if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        cyclicalRef.current
      )
    ) {
      setInCyclical(true);
    } else if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        frictionalRef.current
      )
    ) {
      setInFrictional(true);
    } else if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        structuralRef.current
      )
    ) {
      setInStructural(true);
    } else {
      setInCyclical(false);
      setInFrictional(false);
      setInStructural(false);
    }
  };

  const checkIfInAnyBox = (x, y, element) => {
    let targetX = element.offsetLeft;
    let targetY = element.offsetTop;
    let targetHeight = element.offsetHeight;
    let targetWidth = element.offsetWidth;
    return (
      x >= targetX &&
      x <= targetX + targetWidth &&
      y >= targetY &&
      y < targetY + targetHeight
    );
  };

  const onDragStart = (e) => {
    setDragStarted(true);
  };

  const ifYes = (answer) => answer?.answer === "yes";
  const ifNo = (answer) => answer?.answer === "no";

  const onDragEnd = (e, setDragState) => {
    setDragState();

    if (!inCyclical && !inFrictional && !inStructural) return;

    if (inCyclical) {
      setCurrentAnswer({
        answer: "Cyclical",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    } else if (inFrictional) {
      setCurrentAnswer({
        answer: "Frictional",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    } else if (inStructural) {
      setCurrentAnswer({
        answer: "Structural",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    }
    setAnswered(true);
    setShowQuestion(false)
    setInCyclical(false);
    setInFrictional(false);
    setInStructural(false)
  };

  const getAnswers = (ans) => {
    console.log("in getAnswers", answers.length)
    return filter(answers, { answer: ans });
  }

  return (
    <Grid>
      <Grid container alignItems="center" justify="flex-start">
        <Grid>
          <Typography variant="h4" className={classes.areTheyText} >
          WHAT TYPE OF
          </Typography>
          <Typography variant="h4" className={classes.includedTitle} style={{ marginRight: isMobile  ? '5.8rem' : '8rem' }} >
          UNEMPLOYMENT?
          </Typography>
        </Grid>
        <DraggableAnswer
          showDraggable={showQuestion}
          onDragStart={onDragStart}
          onDragEnd={(e) => onDragEnd(e, () => setDragStarted(false))}
          onDragUpdate={onDragUpdate}
          currentQuestion={currentQuestion}
          dragStarted={dragChildStarted}
          openNextSetModal={openNextSetModal}
          moveBack={moveBack}
        />
      </Grid>
      <Grid className={classes.dropImageContainer}>
        {showDropIconSection && !dragStarted && (
          <Grid container justify="center">
            {answered ? (
              <Button
                // style={{ animationDuration: "1.5s" }}
                className={`${classes.submitButton
                  } animate__animated animate__bounceIn`}
                onClick={() => {
                  setAnsweredCorrectly(currentAnswer.answer === currentQuestion.answer)
                  onSubmit(currentAnswer)
                }}
              >
                Confirm Answer
              </Button>
            ) : showQuestion && (
              <img
                src={dropImage}
                className={`${
                  classes.dropImageStyle
                } animate__animated animate__bounceIn`}
              />
            )}
          </Grid>
        )}
      </Grid>

      <Grid container justify="space-evenly" style={{ marginTop: isMobile && 30 }}>
        <GDPDroppable
          aref={cyclicalRef}
          title="Cyclical"
          inAnswer={inCyclical}
          ifAnswer={ifYes}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          isEvaluatorModalOpen={isEvaluatorModalOpen}
          setAnswered={setAnswered}
          answered={answered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "no" && answeredCorrectly === false}
          isPreview={prevAnswer?.answer === "yes"}
          moveBack={moveBack && isNoFinished}
          setAnimationFinished={setAnimationFinished}
          questionSetIndex={questionSetIndex}
          inNextQuestionSet={currentQuestion.inNextQuestionSet}
          boxTitle={yesBoxTitles[questionSetIndex]}
        />

        <GDPDroppable
          aref={frictionalRef}
          title="Frictional"
          inAnswer={inFrictional}
          ifAnswer={ifNo}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          isEvaluatorModalOpen={isEvaluatorModalOpen}
          setAnswered={setAnswered}
          answered={answered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "yes" && answeredCorrectly === false}
          isPreview={prevAnswer?.answer === "no"}
          moveBack={moveBack}
          setAnimationFinished={setAnimationFinished}
          questionSetIndex={questionSetIndex}
          inNextQuestionSet={currentQuestion.inNextQuestionSet}
          setIsNoFinished={setIsNoFinished}
          boxTitle={noBoxTitles[questionSetIndex]}
        />

        <GDPDroppable
          aref={structuralRef}
          title="Structural"
          inAnswer={inStructural}
          ifAnswer={ifNo}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          isEvaluatorModalOpen={isEvaluatorModalOpen}
          setAnswered={setAnswered}
          answered={answered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "yes" && answeredCorrectly === false}
          isPreview={prevAnswer?.answer === "no"}
          moveBack={moveBack}
          setAnimationFinished={setAnimationFinished}
          questionSetIndex={questionSetIndex}
          inNextQuestionSet={currentQuestion.inNextQuestionSet}
          setIsNoFinished={setIsNoFinished}
          boxTitle={noBoxTitles[questionSetIndex]}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(PlayQuiz);
